module.exports = __webpack_public_path__ + "img/cadeau.92a94652.jpg";